import * as React from 'react';
import {
  Renderer,
  RendererComponentProps,
  ContextObserver
} from '../../../../webana';
import { observer } from 'mobx-react';
import { Subscriber } from 'react-broadcast';

interface DivConfig {
  content?: string;
  style?: React.CSSProperties;
  className?: string;
}

@observer
export class DivComponent extends React.Component<
  RendererComponentProps<DivConfig> & ContextObserver<any>
> {
  render() {
    const { config } = this.props;
    return (
      <div style={config.style} className={config.className}>
        <Renderer content={config.content} />
      </div>
    );
  }
}

export class WebanaDiv extends React.Component<
  RendererComponentProps<DivConfig>
> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => <DivComponent {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/webana/components/div/Div.tsx